module.exports = __webpack_public_path__ + "static/images/success-pic.a295cb8.png";